const Footer = () => {
  return (
    <footer className="bg-pink text-black py-8">
      <div className="container mx-auto text-center text-xs">
        <p>&copy; 2023 Nobue Sato. All rights reserved.</p>
        <p>Designed and developed by Nobue Sato</p>
        <p>Free images are from Canva</p>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://icons8.com/icon/447/linkedin"
        >
          LinkedIn
        </a>{" "}
        icon by{" "}
        <a target="_blank" rel="noreferrer" href="https://icons8.com">
          Icons8
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://icons8.com/icon/12598/github"
        >
          GitHub
        </a>{" "}
        icon by{" "}
        <a target="_blank" rel="noreferrer" href="https://icons8.com">
          Icons8
        </a>
      </div>
    </footer>
  );
};

export default Footer;
